package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class FavoriteTemplateEntity(
  public val id: String,
  public val description: String?,
  public val amountCents: Long,
  public val categoryId: String,
  public val logoEmoji: String?,
  public val logoUri: String?,
  public val isDeleted: Boolean,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
